import React from 'react'
import StyledLink from './Link.Style'

const Link = ({ children, props, href, target }) => {
    return (
        <StyledLink href={href} target={target} {...props}>
            {children}
        </StyledLink>
    )
}

export default Link